<template>
  <div class="bg-grey-lines block-fullscreen">
    <div class="header-logo">
      <icon name="td-logo" color="#393f49" />
    </div>
    <section class="block-fullscreen-center block-step block-fullscreen-text">
      <h1 class="title-section">AGILIDADE OPERACIONAL</h1>
      <div class="title-main">
        <p>No contexto da transformação digital, a otimização dos processos é um pilar fundamental para dar mais agilidade para as empresas, trazer respostas às demandas dos clientes e proporcionar serviços mais eficientes. Pensar os processos de forma diferente tende a gerar resultados ainda não explorados nas empresas.</p>
        <p>Nesta etapa vamos refletir sobre a aplicação de ferramentas, metodologias ágeis, além de confrontar seu mindset em alguns cenários.</p>
      </div>
      <router-link :to="nextScreen" class="nav-arrow-down">
        <div class="title hidden-sm">
          Role para baixo
        </div>
        <icon name="arrow-line-right" class="arrow-right animation-blink" />
      </router-link>
    </section>
  </div>
</template>

<script>
import Icon from '../Icon';
import rollDown from '../mixins/rollDown';

/* eslint-disable max-len */
export default {
  name: 'agilidade_operacional',
  mixins: [rollDown],
  components: { Icon },
  data() {
    return {
      nextScreen: '/teste/agilidade-operacional/formulario',
    };
  },
  mounted() {
    this.$store.commit('SET_BAR_PROGRESS', 3);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/test/OperationalAgility.vue